import styled, { css } from 'styled-components';
import { mobile_xl, mobile_xs, tablet_s } from '../../../global/mediaQueryMixin';

const Main = styled.div`
  max-width: 662px;
  width: 100%;
  margin: 26px auto 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  ${mobile_xl(css`
    margin: 0 auto;
    .fourth-block {
      display: none;
    }
    .fifth-block {
      display: none;
    }
  `)}
`;
const FirstBlock = styled.div`
  padding: 12px 15px 12px 18px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  display: flex;
  gap: 12px;
  z-index: 1111;
  ${mobile_xl(css`
    z-index: 0;
    padding: 12px 12px 12px 18px;
    gap: 16px;
  `)}
`;
const Avatar = styled.div`
  width: 28px;
  height: 28px;
  &.avatar {
    width: 20px;
    height: 20px;
  }
`;
const Profile = styled.div`
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  &.avatar {
    width: 20px;
    height: 20px;
  }
`;
const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  &.right-side {
    flex-direction: row;
    gap: 15px;
    justify-content: space-between;
    width: 100%;
  }
  ${mobile_xl(css`
    gap: 8px;
    width: 100%;
    &.right-side {
      flex-direction: column;
      gap: 8px;
    }
  `)}
`;
const SubDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 5px;
  &.right-side {
    padding-bottom: 5px;
  }
  ${mobile_xl(css`
    &.third-block {
      flex-direction: column-reverse;
    }
    &.right-side {
      padding-bottom: 0px;
    }
  `)}
`;
const Top = styled.div`
  width: 162px;
  height: 10px;
  border-radius: var(--border-radius-6);
  background-color: var(--background-muted);
  &.bottom {
    width: 463px;
  }
  &.right {
    width: 200px;
  }
  &.top {
    width: 481px;
  }
  &.bottomLine {
    width: 463px;
  }
  ${tablet_s(css`
    &.bottomLine {
      width: 342px;
    }
    &.top {
      width: 318px;
    }
    &.bottom {
      width: 344px;
    }
  `)}
  ${mobile_xl(css`
    &.bottom {
      width: -webkit-fill-available;
    }
    &.top {
      width: 210px;
    }
    &.top-bottom {
      width: 116px;
    }
    &.right {
      width: 100%;
    }
    &.bottomLine {
      width: 100%;
    }
  `)}
`;

const Bottom = styled.div`
  width: 112px;
  height: 26px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  &.first {
    width: 99px;
  }
  &.second {
    width: 90px;
  }
  ${mobile_xl(css`
    &.second {
      display: none;
    }
  `)}
`;
const LeftSide = styled.div`
  width: 62px;
  height: 16px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Subbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SubBlock = styled.div`
  padding: 11px;
  border-radius: var(--border-radius-8);
  width: 483px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${tablet_s(css`
    width: 100%;
    max-width: -webkit-fill-available;
  `)}
`;

const BottomDiv = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const LeftDiv = styled.div`
  width: 88px;
  height: 74px;
  ${mobile_xs(css`
    width: 68px;
    height: 68px;
  `)}
`;

const Square = styled.div`
  width: 88px;
  height: 74px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
  ${mobile_xs(css`
    width: 68px;
    height: 68px;
  `)}
`;
const RightDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const Detail = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
const ButtonDiv = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
const Box = styled.div`
  padding: 9px 11px;
  border-radius: var(--border-radius-8);
  width: 481px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: 14px;
  ${tablet_s(css`
    width: 100%;
    max-width: -webkit-fill-available;
  `)}
`;
const ResponsiveBottomDiv = styled.div`
  display: none;
  width: 62px;
  height: 16px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    display: flex;
  `)}
`;
export {
  Main,
  FirstBlock,
  Profile,
  RightSide,
  Top,
  Bottom,
  SubDiv,
  LeftSide,
  Avatar,
  Subbox,
  SubBlock,
  BottomDiv,
  LeftDiv,
  RightDiv,
  Square,
  Detail,
  ButtonDiv,
  Box,
  ResponsiveBottomDiv
};
